import { alpha, type Theme } from "@mui/material/styles";

/**
 * Chat surface tints, taken from the app theme's navy scale
 * (`theme.custom.colors`, defined in `@msys/ui`) so the panel matches the rest
 * of the app. Falls back to a primary tint under a bare MUI theme (specs and
 * hosts that don't mount the `@msys/ui` ThemeProvider).
 */
export function agentHeaderBackground(theme: Theme): string {
  return theme.custom?.colors.navy0 ?? alpha(theme.palette.primary.main, 0.06);
}

export function agentUserBubbleBackground(theme: Theme): string {
  return theme.custom?.colors.navy25 ?? alpha(theme.palette.primary.main, 0.1);
}
